import "@aws-amplify/ui-react/styles.css";
import { App as AApp, ConfigProvider } from "antd";
import axios from "axios";
import { Theme, EndeavourProvider } from "components/Endeavour";
import React, { lazy } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from "react-router-dom";
import "./App.css";
import AppContext from "./AppContext";
import RestrictedLayout from "./RestrictedLayout";
import withAuthenticator from "./components/withAuthenticator";
import SettlementPages from "./pages/Reconciliation/SettlementPages";
import DashboardPage from "./pages/Gateway/DashboardPage";
import PaymentsPage from "./pages/Gateway/PaymentsPage";
import PaymentPage from "./pages/Gateway/PaymentPage";
import UsersPage from "./UsersPage";
import MerchantInformationPage from "./pages/Gateway/MerchantInformationPage";
import TerminalPage from "./pages/Gateway/TerminalPage";
import SettlementDetail from "./pages/Reconciliation/SettlementDetail";
import SettlementDashboardPage from "./pages/Reconciliation/SettlementDashboardPage";
// import MerchantInformationUpdateHistory from "pages/Gateway/MerchantInformationUpdateHistory";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // staleTime: 0,
      // cacheTime: 0,
      refetchOnWindowFocus: false,
    },
  },
});

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<RestrictedLayout />}>
      <Route path="/" element={<DashboardPage />} />
      <Route path="information" element={<MerchantInformationPage />} />
      <Route path="settlement-dashboard" element={<SettlementDashboardPage />} />
      <Route path="settlements" element={<SettlementPages />} />
      <Route path="settlements/:settlementID" element={<SettlementDetail />} />
      <Route path="terminal" element={<TerminalPage />} />
      <Route path="payments" element={<PaymentsPage />} />
      <Route path="payments/:paymentID" element={<PaymentPage />} />
      <Route path="users" element={<UsersPage />} />
    </Route>,
  ),
);

// axios.defaults.baseURL = "http://localhost/resources/card-programs/b58ad182-f15d-42df-9231-ad634a78b0de";
// axios.defaults.baseURL = "https://endeavour.uat.pa-g.com/resources/card-programs/b58ad182-f15d-42df-9231-ad634a78b0de";
axios.defaults.baseURL = "http://localhost";
axios.defaults.timeout = 10000;

function App({ user, signOut }) {
  const [login, setLogin] = React.useState(true);
  return (
    <AppContext.Provider value={{ login: login, setLogin: setLogin, signOut: signOut, user: user }}>
      <AApp>
        <QueryClientProvider client={queryClient}>
          <ConfigProvider
            theme={{
              ...Theme,
            }}
          >
            <EndeavourProvider>
              <RouterProvider router={router} />
            </EndeavourProvider>
          </ConfigProvider>
        </QueryClientProvider>
      </AApp>
    </AppContext.Provider>
  );
}

export default withAuthenticator(App);
